<form
  [formGroup]="checkoutSubmitForm"
  data-cy="checkout-summary-form d-flex"
  class="place-order d-flex flex-column udex-py-4"
>
  <div class="d-flex flex-grow-1 justify-content-end">
    <udex-button
      class="place-order__button flex-grow-1"
      size="Large"
      data-cy="checkout-place-order-button"
      (click)="clearLastPage(); checkPoNumberAndSubmitForm();"
      [disabled]="isPlaceOrderButtonDisabled()"
      type="Submit"
    >
      <div class="d-flex align-items-center">
        <span *ngIf="requestPending; else placeOrder" aria-hidden="true" role="status">
        <ui5-busy-indicator
          size="Medium"
          class="white-dots d-flex"
          active></ui5-busy-indicator>
        </span>
        <ng-template #placeOrder>
          <span>{{ 'checkoutReview.placeOrder' | cxTranslate }}</span>
        </ng-template>
      </div>
    </udex-button>
  </div>
  <label *ngIf="isTermsConditionsLinkShown$ | async" class="text-end udex-pt-16 udex-mb-0">
    <span class="place-order__disclaimer body--xs">{{ 'checkoutReview.confirmThatRead' | cxTranslate }}</span>
    <input
      type="checkbox"
      formControlName="termsAndConditions"
      [checked]=true
      [hidden]="true"
    />
  </label>
  <div *ngIf="isTermsConditionsLinkShown$ | async" class="d-flex justify-content-end">
    <dcp-terms-conditions
      [removalStatus]="entries[0]?.removed"
      [entry]="entries[0]"
      [entries]="entries"
      [isStoreHeaderShown]="true"
    ></dcp-terms-conditions>
  </div>
</form>

<dcp-cyber-source-place-order></dcp-cyber-source-place-order>
